import React, { ReactNode } from 'react'
import styles from '~/styles/molecules/row/row.module.scss'
import css from 'styled-jsx/css'
import { useSpaceLinkColor } from '~/hooks/server/color'

import { addClass } from '~/common/utils/html'
import { ColorWeight, lightenColor } from '~/common/define/color'
import { TagProps } from '~/components/atoms/tag/Tag'
import TagList from '~/components/atoms/tag/TagList'
import ModelsIcon, { ModelIconProps } from '~/components/atoms/icon/ModelsIcon'
import StrongText from '~/components/atoms/text/StrongText'

export enum RowBaseLayoutSize {
  MIDDLE,
  SMALL
}

interface Props {
  tagList: TagProps[]
  content: string|ReactNode
  iconProps?: ModelIconProps
  title?: string
  date?: string
  hoveredContent?: string
}

const RowBaseLayout = ({tagList, content, iconProps, title, date = null}: Props) => {
  const color = useSpaceLinkColor()
  const {className, styles: clickableStyles} = css.resolve`
    .${styles.baseLayout}:hover { background: ${lightenColor(color, ColorWeight.FEATHER)}};
  `

  return (
    <>
      <div className={
        styles.base + addClass(styles.baseLayout) + addClass(className)
      }>
        <span className={styles.baseLayout__header}>
          {tagList.length > 0 &&
            <TagList list={tagList}/>
          }
          {title &&
            <StrongText>{title}</StrongText>
          }
        </span>
        {date &&
          <span className={styles.baseLayout__date}>
            {date}
          </span>
        }
        <div className={styles.baseLayout__body}>
          {iconProps &&
            <ModelsIcon {...iconProps}/>
          }
          {content && <>{content}</>}
        </div>
      </div>
      {clickableStyles}
    </>
  )
}

export default RowBaseLayout
